/**
 * @namespace enyo-ui
 */
require("enyo/touch");
require("enyo-perf/LazyControl");
